import { jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cellPadding, emptyCharacterIfEmpty } from "../constants";
import * as Styled from "./TableCell.styled";
export const TableCell = forwardRef((props, ref) => {
    const { backgroundOpacity, children, defaultCellPadding = cellPadding, textAlign = "left", whiteSpace, isHeader, ...otherProps } = props;
    // Invert the value because "polished" does it the opposite of CSS opacity, for some reason
    const polishedOpacityProp = backgroundOpacity === undefined ? undefined : 1 - backgroundOpacity;
    return (_jsxs(Styled.TableCell, { ref: ref, backgroundOpacity: polishedOpacityProp, defaultCellPadding: defaultCellPadding, textAlign: textAlign, whiteSpace: whiteSpace, ...(isHeader ? { as: "th" } : {}), ...otherProps, children: [children, !isHeader && emptyCharacterIfEmpty(children)] }));
});
TableCell.displayName = "TableCell";
